import { handleActions } from 'redux-actions';
import { logoutUser, fetchAuthTokenActions, changePasswordActions, validateAuthFailed } from '../actions/authActions';

const initialState = {
  username: null,
  authToken: null,
  tokenRequested: false
};

const authReducer = handleActions(
  {
    [logoutUser](state) {
      return { ...state, ...initialState };
    },

    [validateAuthFailed](state, { payload }) {
      return { ...state, error: payload };
    },

    [fetchAuthTokenActions.triggered](state) {
      return { ...state, tokenRequested: true };
    },

    [fetchAuthTokenActions.succeeded](state, { payload }) {
      const { authToken, redirectToHome } = payload;

      if (authToken === state.authToken) {
        return state;
      }

      return {
        state,
        authToken,
        tokenRequested: false,
        redirectToHome
      };
    },

    [fetchAuthTokenActions.failed](state) {
      return {
        state,
        tokenRequested: false
      };
    },

    [changePasswordActions]() {
      return initialState;
    }
  },
  initialState
);

export default authReducer;
